<template>
	<Container>
		<Subtitle>
			{{ 'Creación de correo electrónico' }}
		</Subtitle>
		<div class="p-4">
			<div class="lg:flex mb-4">
				<div class="lg:w-1/4">
					<label class="block mb-2">{{ 'Correo electrónico' }}</label>
					<input type="text" v-model="create_email_email" class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
				</div>
				<div class="lg:w-1/4 lg:pr-2">
					<label class="block mb-2">{{ 'Dominio' }}</label>
					<select v-model="domain" class="
							domainSelect
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						">
						<option v-for="(domain, index) in domains" :value="domain.id" :key="index">
							{{ '@' + domain.name }}
						</option>
					</select>
				</div>
				<div class="lg:w-1/2 lg:pl-2">
					<label class="block mb-2">{{ 'Contraseña' }}</label>
					<input type="text" v-model="create_email_pass" class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
				</div>
			</div>
			<div v-if="this.create_email_success === true" class="text-left">
				<div class="text-sm">Correo creado correctamente</div>
			</div>
			<div v-else-if="this.create_email_success === false" class="text-left">
				<div class="text-sm text-red-500">Se ha producido un error</div>
			</div>
			<ButtonBlack class="mb-6" @click.native="onCreateEmail()">
				<div v-if="loading">
					<pulse-loader :loading="loading" :color="'#fff'" :size="'10px'"></pulse-loader>
				</div>
				<div v-else>{{ buton_text }}</div>
			</ButtonBlack>
			<ButtonBlack class="mb-6" @click.native="onGenerateNewPassword()">
				<div v-if="loading">
					<pulse-loader :loading="loading" :color="'#fff'" :size="'10px'"></pulse-loader>
				</div>
				<div v-else>Generar Contraseña</div>
			</ButtonBlack>
		</div>
		<Subtitle>
			{{ 'Restablecer contraseña de correo electrónico' }}
		</Subtitle>
		<div class="p-4">
			<div class="lg:flex mb-4">
				<div class="lg:w-1/2 lg:pr-2">
					<label class="block mb-2">{{ 'Correo electrónico' }}</label>
					<input type="text" v-model="reset_password_email" class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
				</div>
				<div class="lg:w-1/2 lg:pl-2">
					<label class="block mb-2">{{ 'Contraseña' }}</label>
					<input type="text" v-model="reset_password_pass" class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
				</div>
			</div>
			<div v-if="this.reset_password_success === true" class="text-left">
				<div class="text-sm">Contraseña restablecida correctamente</div>
			</div>
			<div v-else-if="this.reset_password_success === false" class="text-left">
				<div class="text-sm text-red-500">Se ha producido un error</div>
			</div>
			<ButtonBlack class="mb-6" @click.native="onResetPassword()">
				<div v-if="loading">
					<pulse-loader :loading="loading" :color="'#fff'" :size="'10px'"></pulse-loader>
				</div>
				<div v-else>{{ buton_text }}</div>
			</ButtonBlack>
			<ButtonBlack class="mb-6" @click.native="onGenerateResetPassword()">
				<div v-if="loading">
					<pulse-loader :loading="loading" :color="'#fff'" :size="'10px'"></pulse-loader>
				</div>
				<div v-else>Generar Contraseña</div>
			</ButtonBlack>
		</div>
		<Subtitle>
			{{ 'Desactivación de correo electrónico' }}
		</Subtitle>
		<div class="p-4">
			<div class="lg:flex">
				<div class="lg:w-2/3 mb-4 lg:pr-2">
					<label class="block mb-2">{{ 'Correo electrónico' }}</label>
					<input type="text" v-model="disable_email_email" class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
				</div>
			</div>
			<div v-if="this.disable_email_success === true" class="text-left">
				<div class="text-sm">Correo desactivado correctamente</div>
			</div>
			<div v-else-if="this.disable_email_success === false" class="text-left">
				<div class="text-sm text-red-500">Se ha producido un error</div>
			</div>
			<ButtonBlack class="mb-6" @click.native="onDisableEmail()">
				<div v-if="loading">
					<pulse-loader :loading="loading" :color="'#fff'" :size="'10px'"></pulse-loader>
				</div>
				<div v-else>{{ buton_text }}</div>
			</ButtonBlack>
		</div>
		<Subtitle>
			{{ 'Reactivación de correo electrónico' }}
		</Subtitle>
		<div class="p-4">
			<div class="lg:flex">
				<div class="lg:w-2/3 mb-4 lg:pr-2">
					<label class="block mb-2">{{ 'Correo electrónico' }}</label>
					<input type="text" v-model="enable_email_email" class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						" />
				</div>
			</div>
			<div v-if="this.enable_email_success === true" class="text-left">
				<div class="text-sm">Correo activado correctamente</div>
			</div>
			<div v-else-if="this.enable_email_success === false" class="text-left">
				<div class="text-sm text-red-500">Se ha producido un error</div>
			</div>
			<ButtonBlack class="mb-6" @click.native="onEnableEmail()">
				<div v-if="loading">
					<pulse-loader :loading="loading" :color="'#fff'" :size="'10px'"></pulse-loader>
				</div>
				<div v-else>{{ buton_text }}</div>
			</ButtonBlack>
		</div>
	</Container>
</template>

<script>
import { fetchDomainsSelect } from '@/apollo/domains'
import { single } from '@/mixins'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
	apollo: {
		domains: fetchDomainsSelect()
	},
	data() {
		return {
			endpoint: 'generate-signs',
			section: 'generar-firmas',
			domain: null,
			create_email_email: '',
			create_email_success: null,
			create_email_pass: '',
			reset_password_email: '',
			reset_password_success: null,
			reset_password_pass: '',
			delete_email_email: '',
			delete_email_success: null,
			disable_email_email: '',
			disable_email_success: null,
			enable_email_email: '',
			enable_email_success: null
		}
	},
	watch: {
		create_email_email: function (newValue) {
			this.create_email_email = newValue.toLowerCase().replace('@', '')
		},
		reset_password_email: function (newValue) {
			this.reset_password_email = newValue.toLowerCase()
		},
		delete_email_email: function (newValue) {
			this.delete_email_email = newValue.toLowerCase()
		},
		disable_email_email: function (newValue) {
			this.disable_email_email = newValue.toLowerCase()
		},
		enable_email_email: function (newValue) {
			this.enable_email_email = newValue.toLowerCase()
		}
	},
	components: {
		PulseLoader
	},
	mixins: [single],
	methods: {
		generatePassword(length) {
			const chars =
				'0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
			return new Array(length)
				.fill()
				.map(() => chars[Math.floor(Math.random() * chars.length)])
				.join('')
		},
		onGenerateNewPassword() {
			this.create_email_pass = this.generatePassword(16)
		},
		onGenerateResetPassword() {
			this.reset_password_pass = this.generatePassword(16)
		},
		onCreateEmail() {
			if (!this.domain) return
			const domain = this.domains.find(domain => domain.id === this.domain).name
			const email = `${this.create_email_email}@${domain}`
			const password = this.create_email_pass

			this.$axios({
				method: 'post',
				url: '/cpanel/create',
				data: { email, password }
			})
				.then(() => {
					this.create_email_pass = ''
					this.create_email_email = ''
					this.create_email_success = true
					this.$alert('Operación realizada con exitosamente.', '¡Enhorabuena!', 'success')
				})
				.catch(error => {
					const errorMessage = error.response.data.errors[0].message
					this.$alert( errorMessage || 'Error en la solicitud.', 'Error', 'error')
					this.create_email_success = false
				})
		},
		onResetPassword() {
			const email = this.reset_password_email
			const password = this.reset_password_pass

			this.$axios({
				method: 'post',
				url: '/cpanel/restore',
				data: { email, password }
			})
				.then(() => {
					this.reset_password_pass = ''
					this.reset_password_email = ''
					this.reset_password_success = true
					this.$alert('Operación realizada con exitosamente.', "¡Enhorabuena!", "success")
				})
				.catch(error => {
					const errorMessage = error.response.data.errors[0].message
					this.$alert(errorMessage || 'Error en la solicitud.', 'Error', 'error')
					this.reset_password_success = false
				})
		},
		onDeleteEmail() {
			const email = this.delete_email_email

			this.$axios({
				method: 'post',
				url: '/cpanel/delete',
				data: { email }
			})
				.then(() => {
					this.delete_email_email = ''
					this.delete_email_success = true
					this.$alert('Operación realizada con exitosamente.', "¡Enhorabuena!", "success")
				})
				.catch(error => {
					const errorMessage = error.response.data.errors[0].message
					this.$alert( errorMessage || 'Error en la solicitud.', 'Error', 'error')
					this.delete_email_success = false
				})
		},
		onDisableEmail() {
			const email = this.disable_email_email

			this.$axios({
				method: 'post',
				url: '/cpanel/disable',
				data: { email }
			})
				.then(() => {
					this.disable_email_email = ''
					this.disable_email_success = true
					this.$alert('Operación realizada con exitosamente.',"¡Enhorabuena!", "success")
				})
				.catch(error => {
					const errorMessage = error.response.data.errors[0].message
					this.$alert(errorMessage || 'Error en la solicitud.', 'Error', 'error')
					this.disable_email_success = false
				})
		},
		onEnableEmail() {
			const email = this.enable_email_email

			this.$axios({
				method: 'post',
				url: '/cpanel/enable',
				data: { email }
			})
				.then(() => {
					this.enable_email_email = ''
					this.enable_email_success = true
					this.$alert('Operación realizada con exitosamente.', "¡Enhorabuena!", "success")
				})
				.catch(error => {
					const errorMessage = error.response.data.errors[0].message
					this.$alert( errorMessage || 'Error en la solicitud.', 'Error', 'error' )
					this.enable_email_success = false
				})
		}
	}
}
</script>
<style scoped>
.domainSelect {
	margin-top: 0.4em;
}

.emailText {
	text-align: right;
}
</style>
